import {IconBox, IconProps} from "./index";
import React from "react";

import LogoSvg from "../../../assets/icons/logo.svg?react";

export const LogoIcon = (props: IconProps) => {
    return (
        <IconBox {...props}>
            <LogoSvg/>
        </IconBox>
    );
}
